import { useCallback, useState } from 'react';
import { Form } from '../../../../../components';

export const useApplianceCommonState = (form) => {
    const useProxyEnabled = Form.useWatch('useProxyEnabled', form);
    const [advancedSettingsEnabled, setAdvancedSettingsEnabled] = useState(false);
    const [migrationInstructions, setMigrationInstructions] = useState({});
    const [ignoreValidationErrors, setIgnoreValidationErrors] = useState(false);

    const prefillCommonFromAppliance = useCallback(
        (appliance) => {
            if (!!appliance.ca_proxy) {
                form.setFieldsValue({ useProxyEnabled: appliance.ca_proxy });
            }
            if (!!appliance.ignore_validation_errors) {
                setIgnoreValidationErrors(appliance.ignore_validation_errors);
                form.setFieldsValue({ ignoreValidationErrors: appliance.ignore_validation_errors });
            }
            if (appliance.migration_instructions && Object.keys(appliance.migration_instructions).length > 0) {
                setMigrationInstructions(appliance.migration_instructions);
                setAdvancedSettingsEnabled(true);
                form.setFieldsValue({ advancedSettings: true });
            }
        },
        [form],
    );

    const commonConfigProps = {
        advancedSettingsEnabled,
        onAdvancedSettingsChange: setAdvancedSettingsEnabled,
        migrationInstructions,
        onMigrationInstructionsChange: setMigrationInstructions,
        ignoreValidationErrors,
        onIgnoreValidationErrorsChange: setIgnoreValidationErrors,
    };

    return {
        useProxyEnabled,
        migrationInstructions,
        ignoreValidationErrors,
        commonConfigProps,
        prefillCommonFromAppliance,
    };
};

